const FREE_EMAIL_DOMAIN_SET = new Set([
  'gmail.com',
  'yahoo.com',
  'yahoo.co.uk',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'aol.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'mail.com',
  'protonmail.com',
  'proton.me',
  'zoho.com',
  'yandex.com',
  'gmx.com',
  'gmx.net',
  'fastmail.com',
  'tutanota.com',
  'tuta.com',
  'inbox.com',
  'mail.ru',
  'msn.com',
  'qq.com',
  '163.com',
  'sina.com',
  'naver.com',
  'daum.net',
  'hanmail.net',
  'rediffmail.com',
  'web.de',
  'libero.it',
  'virgilio.it',
  'laposte.net',
  'orange.fr',
  'wanadoo.fr',
  'comcast.net',
  'sbcglobal.net',
  'att.net',
  'verizon.net',
  'cox.net',
  'charter.net',
  'earthlink.net',
])

/**
 * Extracts the domain from an email address.
 * Returns null if the email is invalid.
 */
export const extractEmailDomain = (email: string): string | null => {
  const parts = email.trim().split('@')
  if (parts.length !== 2) return null
  return parts[1]?.toLowerCase() ?? null
}

/**
 * Returns the custom (non-free) domain from an email address, or null
 * if the email belongs to a free provider (Gmail, Yahoo, etc.).
 */
export const extractCustomDomainFromEmail = (email: string): string | null => {
  const domain = extractEmailDomain(email)
  if (!domain) return null
  if (FREE_EMAIL_DOMAIN_SET.has(domain)) return null
  return domain
}
